import React from 'react';

import TooltipPortal from '~components/TooltipPortal';
import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

const StatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const { status, email_failure_reason } = row || {};
  const { colour, name, tag } = status || {};
  const colorHex = colour ? `#${colour}` : undefined;
  const showTooltip = tag === 'not_emailed' && !!email_failure_reason;
  const badgeId = `status-badge-${row?.id}`;

  return (
    <>
      <span
        id={badgeId}
        style={{ color: colorHex, fontWeight: 'bold', cursor: showTooltip ? 'help' : undefined }}
      >
        {name || ''}
      </span>
      {showTooltip && (
        <TooltipPortal targetId={badgeId} content={email_failure_reason} placement="top" limitWidth={300} />
      )}
    </>
  );
};

export default StatusBadge;
